export const porTexts = {
	knowMore: 'Saber mais',
	ngoPurpose:
		"To raise funds for the NGO's projects, keep you up	to date on the NGO and the progress of the project you donated to and issue tax	deduction certificates.",
	termsPurpose:
		'Manage the business relationship in all its fields, as well as its donation and certificate application, and the sending of commercial communications electronically.',
	termsRights:
		'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
	termsAdditionalInfo:
		'You can consult additional and detailed Data Protection information on our <a href="https://www.worldcoo.com/gdpr">website</a> or by <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>',
	termsRecipients:
		'No se cederán datos a terceros, excepto a los encargados de tratamiento fuera de la UE, acogidos a Privacy Shield.',
	unexpectedError: 'Ocorreu um erro inesperado',
	amountError: 'A quantia de dinheiro não era válida',
	authError: 'Ocorreu um erro ao autorizar o pagamento',
	cardError: 'Ocorreu um erro com seu cartão',
	referralError: 'Ocorreu um erro de referência',
	transactionError: 'Ocorreu um erro na transação',
	resetFilters: 'redefinir filtros',
	category: 'Causa',
	basicNeeds: 'Básico',
	humanRights: 'Direitos Humanos',
	education: 'Educação',
	emergency: 'Emergência',
	feeding: 'Alimentação',
	environment: 'Ambiente',
	habitat: 'Habitat',
	health: 'Saúde',
	clear: 'Limpar',
	active: 'Ativo',
	finished: 'Finalizado',
	status: 'Doença',
	filters: 'Filtros',
	year: 'Ano',
	dedicateToTemplate:
		'Hello! You receive this email because {{donorName}} has given you a donation of {{amount}} {{currency}} for the NGO {{ngoName}} in the campaign {{campaignName}}. This donation has been dedicated to you with the intention of making the world a little better place',
	dedicateToTemplateTitle: 'Sua mensagem de dedicação',
	dedicateToWarning:
		'Esta mensagem será enviada ao Destinatário no endereço de e-mail fornecido acima. Confirmo que solicitei permissão do destinatário para enviar esta mensagem',
	dedicateToRecipientEmail: 'Email do destinatário.',
	dedicateToRecipientName: 'Nome do destinatário.',
	dedicateDonationTitle: 'Dedique a doação.',
	dedicateDonationMessage: 'Eu gostaria de dedicar minha doação a alguém',
	responsable: 'Controller',
	purpose: 'Objetivo',
	legitimation: 'Autenticação',
	recipients: 'Destinatários',
	telefonicaTermsAndConditionsLink: 'os termos do Aviso Legal da Fundación Telefónica',
	rights: 'Direitos',
	ngoAdditionalInfoTitle: 'Localização e informações adicionais',
	termsButton: 'Eu li, aceito e entendo',
	id: 'NIF / NIE',
	taxId: 'CIF',
	passport: 'Passaporte',
	others: 'Outros',
	campaignAudited: 'Campanha auditada por',
	termsAndCons: 'termos do Worldcoo Data Protection',
	ngoTerms: 'Termos de proteção de dados de',
	haveReadAndAccept: 'Eu li, entendi e os aceito',
	aCampaignBy: 'Uma campanha de',
	acceptNgoTermsLink: 'termos de Proteção de Dados da {{ngo}}',
	acceptRecurrentTermsLink:
		'Eu li, entendi e aceito os <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">termos de Proteção de Dados das ONGs</a>',
	activities: 'Atividades',
	additionalInfo: 'Informação adicional',
	anyComments: 'Você quer fazer um comentário?',
	businessName: 'Nome da empresa',
	campaignObjectives: 'Objetivos da campanha',
	campaignFunded: 'Campanha financiada',
	campaigns: 'Campanhas',
	cancel: 'Cancelar',
	cardBrandNotAccepted: 'Este tipo de cartões não é aceito.',
	cardRegisteredSuccessfully: 'O cartão foi registrado com sucesso',
	cardsSupported: 'Cartões suportados:',
	certificateOnlyValidInExpeditionCountry:
		'O certificado de doação só será válido no país de origem onde a entidade beneficiária está registada.',
	certificateNeededData: 'Dados necessários para obter o certificado de doação:',
	change: 'Alterar',
	checkoutSuccess: 'Sua doação foi feita corretamente, obrigado por participar.',
	city: 'Cidade',
	collectedFundsDistribution: 'Os fundos coletados serão divididos igualmente entre os seguintes projetos:',
	comments: 'Comentários',
	company: 'Empresa',
	confirm: 'Confirmar',
	contactData: 'Dados de contato',
	cookiesMessage: 'Este site usa cookies. Se você continuar a navegar, considere aceitar seu uso.',
	country: 'País',
	creditCard: 'Cartão de crédito',
	dataReceivedSuccessfully: 'Recebemos corretamente seus dados.',
	description: 'Descrição',
	directBeneficiaries: 'Beneficiários Diretos',
	directBeneficiariesDescription:
		'Aquelas pessoas que de forma natural têm sido beneficiadas pelas ações desenvolvidas pelo projeto.',
	documentNumber: 'Nº do documento',
	documentType: 'Tipo de documento',
	donationAmount: 'Valor da doação',
	donationAmountError: 'O valor da doação não é correto',
	donationAmountMinimumIs: 'O valor mínimo é de {{amount}}',
	donationCertificate: 'Certificado de doação',
	donations: 'Doações',
	donors: 'Doadores',
	donated: 'Doado',
	donatedOf: 'Doado de',
	donateMonthly: 'Doe mensalmente',
	donationOnBehalf: 'Faça uma doação em nome de',
	door: 'Porta',
	email: 'Correio eletrônico',
	fillFollowingFields: 'Preencha os seguintes campos',
	finish: 'Terminar',
	floor: 'Piso',
	funded: 'Financiado',
	genericCardError: 'Houve algum erro com o seu cartão.',
	goBack: 'Voltar',
	identityDocument: 'Identidade',
	indicateDataToIdentify: 'Diga-nos esta informação para que possamos identificá-lo:',
	indirectBeneficiaries: 'Beneficiários indiretos',
	indirectBeneficiariesDescription:
		'Aquelas pessoas identificáveis, que recebem um efeito potencial das ações desenvolvidas no projeto.',
	inDoubtContactHere: 'Qualquer dúvida que você tenha você pode nos contatar aqui:',
	informYouViaMail: 'Vamos informá-lo em detalhes por email.',
	makeDonation: 'Fazer a doação',
	makeOneTimeDonation: 'Faça uma doação única',
	makeYourDonation: 'Faça a sua doação',
	manageMyDonations: 'Gerenciar minhas doações',
	manyThanks: 'Obrigado!',
	modifyAmount: 'Modifique o valor da doação',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">Recebemos sua solicitação corretamente.</p><p>Dentro de alguns dias, enviaremos um e-mail confirmando que fizemos as alterações solicitadas.</p><p>Se tiver alguma dúvida, pode contactar-nos aqui:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Se você já é doador, aqui você pode modificar ou cancelar sua doação:',
	moreInfo: 'Mais informação',
	name: 'Nome',
	next: 'Próximo',
	otherAmount: 'Outro montante',
	overlayError:
		'<p>Ocorreu um erro</p><p>Por favor, tente novamente mais tarde ou entre em contato conosco:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Particular',
	paymentData: 'Informações de pagamento',
	paymentType: 'Forma de pagamento',
	personalData: 'Dados pessoais',
	pleaseFillFields: 'Por favor, preencha as seguintes informações:',
	postalCode: 'Código postal',
	province: 'Província',
	raised: 'Angariado',
	raisedTillNow: 'Criado até agora:',
	recurrentFormError:
		'Algum erro ocorreu ao processar sua solicitação. Por favor, tente novamente mais tarde ou entre em contato conosco:',
	region: 'Região',
	repeatEmail: 'Repita o email',
	repsolEmployeesPortal: 'Portal de solidariedade dos funcionários',
	seeCampaigns: 'Veja campanhas',
	send: 'Enviar',
	share: 'Compartilhe',
	sorry: 'Sentimos muito!',
	stairNumber: 'Escada',
	step1: 'Passo 1',
	step2: 'Passo 2',
	step3: 'Passo 3',
	step4: 'Passo 4',
	stopMakingDonation: 'Pare de doar mensalmente',
	streetName: 'Nome da estrada',
	streetNumber: 'Nome.',
	streetType: 'Tipo de trilha',
	summary: 'Resumo',
	surname: 'Apelidos',
	telefonicaUseCorporateMail:
		'* Se você é um empregado da Telefónica activo utilizado de preferência o seu e-mail corporativo.',
	thanks: 'Obrigado!',
	typeTheAmount: 'Digite o valor',
	unavailableLanguageMessage:
		'Não temos o conteúdo desta campanha em português. Trabalhamos constantemente para fornecer mais conteúdo em seu idioma. Obrigado pela sua paciência.',
	updatesAndLinks: 'Atualizações e links',
	validationEqualFields: 'Os campos {{label}} e {{fieldName}} não são os mesmos',
	validationIsRequired: 'O campo {{label}} é necessário',
	validationValidEmail: 'O campo {{label}} não é um email válido',
	viewCampaignInfo: 'Veja a informação da campanha',
	viewInfo: 'Veja informações',
	wantCertificate: 'Quero receber um certificado de doação',
	wantWorldcooNewsletter: 'Desejo receber informações da Worldcoo',
	whatIsNewAmount: 'Diga-nos qual é o novo valor que você deseja doar (em {{currency}}):',
	whatYouWantToDo: 'Que pretende fazer?',
	whoWillBenefit: 'Quem se irá beneficiar?',
	youCanAlsoDonateOneTime: 'Você também pode fazer uma doação pontual, acessando qualquer um deles.',
	yourDonationWillBeCharged: 'Sua doação será cobrada no dia 15 de cada mês.',
	yourRequestIsProcessing: 'Sua solicitação está sendo processada. Espere alguns segundos, por favor.',
	youSureCancelRecurrentDonation: 'Tem certeza de que deseja parar de fazer uma doação mensal?',
	ngoTermsTitle: 'Informações básicas sobre proteção de dados',
	ngoLegitimation: 'The legal basis for handling your data is your consent.',
	ngoRecipients: 'No data shall be transferred to third parties.',
	ngoRights:
		'Você tem o direito de acessar, retificar e excluir os dados, bem como outros direitos, conforme explicado nas informações adicionais.',
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	ngoAdditionalInfoUrl:
		'Você pode consultar as informações adicionais e detalhadas sobre Proteção de Dados em nosso site: ',
	amountMustBeGreaterThanZero: 'O valor deve ser maior que 0',
	amountMustBeLowerThan3000: 'O valor deve ser inferior a 3.000',
	inSupportOf: 'Em apoio a',
	metafieldsNoTicket: 'Linha 0. Doação sem entrada',
	metafieldsTickets:
		'Quantos convites precisa para o concerto? Tenha em atenção que por cada 10€ doados recebe um convite.',
};
